import React from 'react';
import {Typography, Icon} from "@bonprix/design-system";

export const ItemHeader = ({iconName, headline}) => {
    if (!headline) {
        return <></>;
    }
    return (
        <div className={"side-section-details-header"}>
            <div className={"side-section-details-header-icon"}>
                <Icon variant={iconName}/>
            </div>
            <div className={"side-section-details-header-headline"}>
                <Typography variant={"body2"}>{headline}</Typography>
            </div>
        </div>
    );
};